// Prints date as "Mon day, YYYY"
export default function formatRenewalDate(isoString) {
  const [m, d, y] = new Date(isoString)
    .toDateString()
    .slice(4)
    .split(" ");
  return `${m} ${parseInt(d, 10)}, ${y}`;
}
